<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M8.333 55.667V8.333h47.333v47.334H8.333zm-3-49.334a1 1 0 011-1h51.333a1 1 0 011 1v51.334a1 1 0 01-1 1H6.333a1 1 0 01-1-1V6.333zm15.374 9.04a1 1 0 00-1.414-1.413l-5.334 5.333a1 1 0 001.414 1.414l5.334-5.333zm8 6.587a1 1 0 010 1.414l-5.334 5.333a1 1 0 01-1.414-1.414l5.334-5.333a1 1 0 011.414 0zm0-6.586a1 1 0 00-1.414-1.414L13.959 27.293a1 1 0 001.414 1.414l13.334-13.333z"/></svg>